{
  "it": {
    "space": {
      "actions": {
        "assignOtherUnit": "Riassegna a un'unità",
        "assignSpace": "Assegna pertinenza",
        "assignUnit": "Assegna a un'unità",
        "cancel": "Annulla",
        "closeEdit": "Chiudi modifica",
        "create_space": "Crea pertinenza",
        "delete": "Elimina",
        "edit": "Modifica",
        "goToSpaces": "Crea nuove pertinenze",
        "new": "Pertinenza",
        "save": "Salva",
        "unassign": "Annulla assegnazione unità",
        "unassignSpaces": "Annulla assegnazione pertinenze"
      },
      "attributes": {
        "category": "Tipo",
        "description": "Descrizione",
        "level": "Livello",
        "name": "Nome",
        "price_value": "Valore totale di vendita",
        "price_value_construction": "Valore di costruzione",
        "price_value_land": "Valore del terreno",
        "quotity": "Quotità di trasferimento",
        "status": "Stato",
        "unit": "Unità"
      },
      "category": {
        "bicyclestorage": "Deposito bici",
        "cellar": "Cantina",
        "garagebox": "Box auto",
        "other": "Altro",
        "outdoor_space": "Spazio esterno",
        "parkinglot": "Posto auto",
        "storage": "Deposito generico",
        "winecellar": "Cantina vini"
      },
      "labels": {
        "allSpacesAssigned": "Tutte le pertinenze sono state assegnate a un'unità.",
        "assignedSpaces": "Pertinenze assegnate",
        "internal": "Interno",
        "noCategory": "Nessun tipo definito",
        "noSpaceAssigned": "Nessuna pertinenza assegnata",
        "noSpaces": "Nessuna pertinenza creata",
        "notAssignedToUnit": "Nessuna unità assegnata",
        "onlyAvailableSpacesShown": "Vengono mostrate solo le pertinenze disponibili",
        "selectToUnassign": "Selezioni per annullare l'assegnazione",
        "space": "Pertinenza",
        "spaces": "Pertinenze",
        "spacesProject": "Pertinenze nel progetto {project}",
        "unassignedSpaces": "Pertinenze non assegnate"
      },
      "validation": {
        "needCategory": "Il tipo è obbligatorio",
        "needName": "Nome obbligatorio",
        "needNumber": "Deve essere un numero (ad es. 95)",
        "selectSpace": "Selezioni almeno una pertinenza"
      }
    }
  }
}
